<template>
  <div></div>
</template>

<script>
import { authChange } from '@/webpublicapi/login'
import cookie from "@/utils/cookie";

export default {
  name: 'AuthChange',
  data() {
    return {}
  },
  created() {
    const fromToken = this.$route.query.fromToken
    const fromCountry = this.$route.query.fromCountry
    const url = this.$route.query.url
    authChange({ fromToken, fromCountry }).then(({ code, data }) => {
      if (code === 1000) {
        cookie.set('token', data.token);
        this.$router.replace(url)
      } else {
        throw new Error()
      }
    }).catch(_ => {
      this.$router.replace('/user/login')
    })
  }
}
</script>